import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { routing, appRoutingProviders } from './ng-jax-shared.routing';

import { AlertComponent, DialogContentComponent, DialogSpinnerComponent } from './alert/alert.component';
import { WinBaseComponent } from './win/base/win-base/win-base.component';
import { MessageService } from './services/message-service/message.service';
import { ReverseStringPipe } from './pipes/reverse-string/reverse-string.pipe';

@NgModule({
  imports: [
    BrowserAnimationsModule, FormsModule,
    routing,
    MatButtonModule, MatCheckboxModule, MatTooltipModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatIconModule,
    MatSelectModule, MatProgressSpinnerModule
  ],
  declarations: [
    AlertComponent, DialogContentComponent, DialogSpinnerComponent, WinBaseComponent,
    ReverseStringPipe
  ],
  exports: [
    AlertComponent, WinBaseComponent, ReverseStringPipe
  ],
  providers: [appRoutingProviders, MessageService]
})
export class NgJaxSharedModule { }
